<template>
  <div
    :class="$style.item"
    v-test="'register-payment-order-item'"
  >
    <div :class="$style.number">{{ item.quantity }}</div>
    <div :class="$style.name">
      <span> {{ item.name }}</span>
      <div
        v-if="
          item.discount ||
          (item.loyaltyPointsAmount && item.loyaltyPointsAmount > 0)
        "
        :class="$style.discount"
      >
        (
        <div v-if="item.discount">
          <div
            v-if="item.discount > 0"
            :class="$style.prices"
          >
            {{ `${Math.round(item.discount)}% ${$t('global.discount')}` }}
          </div>
          <div v-if="item.discount < 0">
            {{ `${Math.round(item.discount).toString().replace('-', '')}% ${$t(
                'dynamic_pricing.adjustment_types.percentage_increase'
              )}` }}
          </div>
        </div>
        <div
          v-if="item.loyaltyPointsAmount && item.loyaltyPointsAmount > 0"
          :class="$style.loyaltyPoints"
        >
          <div
            v-if="item.discount"
            :class="$style.comma"
          >
            ,
          </div>
          {{ `${$t('register.loyalty_points_used', {
              points: item.loyaltyPointsAmount
            })}` }}
        </div>
        )
      </div>
      <div :class="$style.prepaid">
        <BaseText
          v-if="item.usedPrepaidCardId"
          color="secondary"
          size="s"
          v-test="'register-order-item-usedprepaidcard'"
        >
          {{ `${$t('register.prepaid_card_applied', {
              card: prepaidCardTransaction?.name
            })}`.toUpperCase() }}
        </BaseText>
      </div>
    </div>
    <div :class="$style.price">
      <div v-if="item.discount !== 0">
        <BaseText
          lineThrough
          inline
          v-test="'register-order-item-top-price-original'"
        >
          {{ filters.currency(item.quantity! * item.originalPrice!) }}
        </BaseText>
      </div>
      <div v-test="'register-order-item-top-price'">
        {{ filters.currency(item.price! * item.quantity!) }}
      </div>
    </div>
  </div>
</template>
<script
  lang="ts"
  setup
>
import { computed } from 'vue';
import filters from '@/filters';
import {
  type OrderItem,
  type OrderTransaction,
  useRegisterOrderStore,
} from '@/modules/register/stores/order';

const { order } = useRegisterOrderStore();

const props = defineProps<{ item: OrderItem }>();

const prepaidCardTransaction = computed(() =>
  order.transactions.find(
    (transaction: OrderTransaction) =>
      Number.parseInt(transaction.prepaidCardId as string) ===
      Number(props.item.usedPrepaidCardId),
  ),
);
</script>
<style
  lang="scss"
  module
>
.item {
  display: flex;
  align-items: center;
}

.number {
  min-width: 30px;
}

.loyaltyPoints {
  display: flex;
  align-items: flex-start;
}

.comma {
  margin-right: $spacing * 0.2;
}

.name {
  flex: 1;
  display: flex;
  gap: $spacing * 0.5;
  flex-wrap: wrap;
  align-items: center;
}

.price {
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;
}

.discount {
  display: flex;
  align-items: flex-start;
  color: #9c9aa0;
}

.prices {
  display: flex;
  align-items: flex-start;
}

.prepaid {
  display: flex;
  align-items: center;
  margin-top: $spacing * 0.1;
}
</style>
